export const getMeasuringElementStyles = () => `
  position: absolute;
  visibility: hidden;
  top: -9999px;
  left: -9999px;
  width: 240px;
  margin: 0;
  padding: 0;
  font-family: 'Figtree', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  white-space: pre-wrap;
  word-wrap: break-word;
  box-sizing: border-box;
`;
//# sourceMappingURL=Tooltip.utils.js.map